import { colors } from "./config";

export const Button = {
  variants: {
    primary: {
      bg: colors.brand.primary.base,
      color: 'white',
      _hover: {
        bg: colors.brand.primary.dark,
        _disabled: {
          bg: colors.brand.primary.disabled,
        }
      },
      _disabled: {
        bg: colors.brand.primary.disabled,
      }
    },
    secondary: {
      color: colors.brand.primary.base,
      border: `2px solid ${colors.brand.primary.base}`,
      ':hover': {
        bg: 'transparent',
        borderColor: colors.brand.primary.dark,
        color: colors.brand.primary.dark,
      }
    },
    tertiary: {
      color: 'brand.500',
      bgColor: 'white',
      border: `1px solid`,
      borderColor: 'brand.500',
      ':hover': {
        bg: 'transparent',
        borderColor: colors.brand.primary.dark,
        color: colors.brand.primary.dark,
      }
    },
    light: {
      color: 'gray.500',
      bgColor: 'gray.100',
      fontWeight: '500',
      _hover: {
        bgColor: 'gray.200',
      }
    },
    destructive: {
      color: 'white',
      bg: colors.error.base,
      _hover: {
        bg: colors.error.dark,
        _disabled: {
          bg: colors.error.mid,
        }
      },
      _disabled: {
        bg: colors.error.mid,
      }
    },
    cancel: {
      color: 'white',
      bg: colors.cancel.base,
      _focus: {
        boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6) !important',
      },
      ':hover': {
        bg: colors.cancel.dark,
      }
    },
    submit: {
      bg: colors.brand.primary.base,
      color: 'white',
      ':hover': {
        bg: colors.brand.primary.dark,
      }
    },
    'plus-circle': {
      borderRadius: "50%",
      bg: 'brand.500',
      color: 'white',
      height: '56px',
      width: '56px',
      fontSize: '2rem',
      transition: '0.2s ease all',
      _hover: {
        bg: 'brand.900',
      },
      _active: {
        bg: 'brand.900',
      },
      _focus: {
        bg: 'brand.900',
      },
    },
  },
  sizes: {
    xl: {
      height: '54px',
      paddingLeft: '30px',
      paddingRight: '30px',
      fontSize: '1.125rem',
    },
  }
};
